/* eslint-disable no-param-reassign */
/**
 * @deprecated
 */
export const rotateHeader = (key: string, config: any) => {
  config[`${key}Rotate`] = 2;
};
/**
 * @deprecated
 */
export const centerHeader = (key: string, config: any) => {
  config[`${key}Align`] = 'Center';
};
/**
 * @deprecated
 */
export const spanHeader = (key: string, count: number, config: any) => {
  config[`${key}Span`] = count;
};
